import React from "react";
import PropTypes from "prop-types";
import { Image } from "@learningblocks/shared-components";
import "./style.scss";

import { HighlightHTML } from "@learningblocks/storybook-components";

export function FullWidthImage(props) {
  const image = (
    <Image
      src={props.image}
      alt={props.altText}
      className={props.className}
      width="100%"
    />
  );
  if (props.caption) {
    return (
      <figure className="fullWidthImage">
        {image}
        <figcaption>
          <HighlightHTML
            key={props.id}
            content={props.caption}
            getContentData={props.getContentData}
            openGlossary={props.openGlossary}
          />
        </figcaption>
      </figure>
    );
  } else if (props.imageWithZoom) {
    return <>{image}</>;
  } else {
    return image;
  }
}

FullWidthImage.propTypes = {
  type: PropTypes.string,
  content: PropTypes.array,
  image: PropTypes.string.isRequired,
  className: PropTypes.string,
  caption: PropTypes.string,
};
